module.exports = __webpack_public_path__ + "static/media/24.86c97567.mp3";